import { messagingPurpose } from 'src/shared/inf-tabela-descricao/MessagingPurpose.enum.js'

export const getPurposeIcon = (purposeId) => {
  const p = messagingPurpose()
  const icons = {
    [p.ONE_TIME_PAYMENT.key]: 'local_atm',
    [p.INSTALLMENT.key]: 'event',
    [p.REGULAR_INVOICE.key]: 'notifications',
    [p.NOTICE.key]: 'warning',
    [p.ADDITIONAL.key]: 'account_balance'
  }
  return icons[purposeId] || 'description'
}

export const getPurposeColor = (purposeId) => {
  const p = messagingPurpose()
  const colors = {
    [p.ONE_TIME_PAYMENT.key]: '#1976d2',
    [p.INSTALLMENT.key]: '#f57c00',
    [p.REGULAR_INVOICE.key]: '#388e3c',
    [p.NOTICE.key]: '#d32f2f',
    [p.ADDITIONAL.key]: '#7b1fa2'
  }
  return colors[purposeId] || '#757575'
}

export const getPurposeLabel = (purposeId) => {
  const p = messagingPurpose()
  const labels = {
    [p.ONE_TIME_PAYMENT.key]: p.ONE_TIME_PAYMENT.label,
    [p.INSTALLMENT.key]: p.INSTALLMENT.label,
    [p.REGULAR_INVOICE.key]: p.REGULAR_INVOICE.label,
    [p.NOTICE.key]: p.NOTICE.label,
    [p.ADDITIONAL.key]: p.ADDITIONAL.label
  }
  return labels[purposeId] || 'Desconhecido'
}
